import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MenuManageFilledStandard.js";
import l from "../components/PfIcon.js";
const e = (a, r) => {
  const t = {
    ...a,
    ...r.attrs
  };
  return n(l, o(t, {
    icon: d
  }), null);
};
e.displayName = "MenuManageFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
